function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileWxTropical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 128.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,72.38A42.65,42.65,0,0,1,97,101.48c-3,3.24-8.2-.39-6.26-4.36A28.67,28.67,0,0,0,93.38,89a.9.9,0,0,0-1.54-.76A40.91,40.91,0,0,1,63.79,100C44,100,18.55,84.29,19.07,54.06A42.65,42.65,0,0,1,30.62,25c3-3.24,8.2.39,6.26,4.36a28.89,28.89,0,0,0-2.69,8.09.91.91,0,0,0,1.55.76A40.88,40.88,0,0,1,63.79,26.48C83.54,26.48,109,42.15,108.5,72.38ZM42.94,21.86a24.31,24.31,0,0,1,5.17-4,18,18,0,0,1,6-2.17h.06a2.07,2.07,0,0,0-.31-4.12,22.4,22.4,0,0,0-8,1.53A30,30,0,0,0,38.84,17l-.05,0a3.27,3.27,0,0,0-.35.3,3.19,3.19,0,1,0,4.5,4.53Zm23.48-6.17h0a1.35,1.35,0,0,0,.81-2.57,28.85,28.85,0,0,0-5.41-1.71h0a2.21,2.21,0,0,0-.37,0,1.89,1.89,0,0,0,0,3.78A26.78,26.78,0,0,1,66.42,15.69Zm18.22,88.89a24.52,24.52,0,0,1-5.17,4,18,18,0,0,1-6,2.18h-.06a2.07,2.07,0,0,0,.31,4.12,22.72,22.72,0,0,0,8-1.53,30.08,30.08,0,0,0,7.08-3.87l0,0a2.51,2.51,0,0,0,.35-.31,3.19,3.19,0,1,0-4.49-4.52Zm-23.48,6.17h0a1.35,1.35,0,0,0-.81,2.57A29.6,29.6,0,0,0,65.74,115h0a2,2,0,0,0,.36,0,1.89,1.89,0,1,0,0-3.78A25.86,25.86,0,0,1,61.16,110.75ZM45.76,45.19a25.49,25.49,0,1,0,36.05,0A25.49,25.49,0,0,0,45.76,45.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.79,
    cy: 63.22,
    r: 13.44,
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWxTropical);
export default __webpack_public_path__ + "static/media/tile_WXTropical.0371474ab5603836e91aae6279fefaa9.svg";
export { ForwardRef as ReactComponent };